import React from 'react'
import {
  Chip,
  Avatar,
  Tooltip
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { faBarcode, faBox, faBan } from "@fortawesome/free-solid-svg-icons";
import { EnumStatusEmbarque } from "../../shared/Enumerables";

const IconEmbarquesStatus = ({ idStatus }) => (
    <>
      {idStatus === EnumStatusEmbarque.Creado ? (
        <>
          <Avatar
            sx={{
            width: 50,
            height: 50,
            bgcolor: "recibido.main",
            marginBottom: "5px",
            }}
            variant="rounded"
        >
            <FontAwesomeIcon icon={faBarcode} />
        </Avatar>
        <Tooltip title="Creado" placement="top">
            <Chip
            label="Creado"
            sx={{ bgcolor: "recibido.main", color: "#fff" }}
            />        
        </Tooltip>
        </>
      ) : idStatus === EnumStatusEmbarque.En_Transito ? (
        <>
        <Avatar
            sx={{
            width: 50,
            height: 50,
            bgcolor: "primary.main",
            marginBottom: "5px",
            }}
            variant="rounded"
        >
            <LocalShippingIcon />
        </Avatar>
        <Tooltip title="En tránsito" placement="top">
            <Chip
            label="En tránsito"
            color="primary"
            />        
        </Tooltip>
        </>
      ) : idStatus === EnumStatusEmbarque.Entregado ? (
        <>
          <Avatar
            sx={{
            width: 50,
            height: 50,
            bgcolor: "success.main",
            marginBottom: "5px",
            }}
            variant="rounded"
        >
            <FontAwesomeIcon icon={faBox} />
        </Avatar>
        <Tooltip title="Entregado" placement="top">
            <Chip
            label="Entregado"
            color="success"
            />        
        </Tooltip>
        </>
      ) : idStatus === EnumStatusEmbarque.No_Entregado  ? (
        <>
          <Avatar
            sx={{
            width: 50,
            height: 50,
            bgcolor: "recibido.main",
            marginBottom: "5px",
            }}
            variant="rounded"
        >
            <FontAwesomeIcon icon={faBan} />
        </Avatar>
        <Tooltip title="No entregado" placement="top">
            <Chip
            label="No entregado"
            sx={{ bgcolor: "recibido.main", color: "#fff" }}
            />        
        </Tooltip>
        </>
      ) : (
        <></>
      )}
    </>
  );

export default IconEmbarquesStatus;